export enum COOKIE_NAME {
  dealerId = 'DID',
  partnerId = 'PAID',
}

export const getCookie = (name: string): string | undefined => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (!match) return;
  return match[2];
};
